var exports = {
  "kL": "DiscoveryPage.module__container___NUtjX3",
  "Gm": "DiscoveryPage.module__scrollBody___NUtjX3",
  "Qs": "DiscoveryPage.module__content___NUtjX3",
  "LB": "DiscoveryPage.module__browseLayout___NUtjX3",
  "bK": "DiscoveryPage.module__searchLayout___NUtjX3",
  "LG": "DiscoveryPage.module__resultsColumn___NUtjX3",
  "Yt": "DiscoveryPage.module__resultsSurface___NUtjX3",
  "qM": "DiscoveryPage.module__virtualGrid___NUtjX3",
  "lJ": "DiscoveryPage.module__gridRow___NUtjX3",
  "sw": "DiscoveryPage.module__loadingMore___NUtjX3",
  "sM": "DiscoveryPage.module__srOnly___NUtjX3",
};

module.exports = exports;
